/* No API calls, app interception, pricing or tracking changes. */
(() => {
  'use strict';
  if (customElements.get('fg-mobile-navigation')) return;
  class FeelGoodMobileNavigation extends HTMLElement {
    connectedCallback() {
      // Shopify can reconnect a section in the editor. One listener set per mount.
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-fg-nav-open]');
      this.fallback = this.querySelector('.fg-nav__fallback');
      this.closeButton = this.querySelector('[data-fg-nav-close]');
      if (!this.dialog || !this.trigger || !this.closeButton || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.desktop = matchMedia('(min-width: 990px)');
      this.trigger.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.cleanup(); }, options);
      this.dialog.addEventListener('pointerdown', event => {
        this.startedOnBackdrop = this.isBackdrop(event);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (this.startedOnBackdrop && this.isBackdrop(event)) this.close();
        this.startedOnBackdrop = false;
        const link = event.target.closest('a[href]');
        if (link && !link.closest('.fg-nav__localization') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) this.close(false);
      }, options);
      this.desktop.addEventListener('change', event => { if (event.matches) this.close(false); }, options);
      window.addEventListener('pagehide', () => this.close(false), options);
      window.addEventListener('pageshow', event => { if (event.persisted) this.close(false); }, options);
      this.trigger.hidden = false;
      if (this.fallback) this.fallback.hidden = true;
    }
    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const r = this.dialog.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    }
    open() {
      if (this.desktop.matches || this.dialog.open) return;
      // Native top layer supplies focus containment/inert background, above chat/header.
      this.dialog.showModal();
      this.returnFocus = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.lockScroll();
      this.closeButton.focus({ preventScroll: true });
    }
    close(returnFocus = true) {
      this.returnFocus = returnFocus;
      if (this.dialog?.open) this.dialog.close();
      this.cleanup();
    }
    lockScroll() {
      if (this.scrollState) return;
      const body = document.body;
      const properties = { position: 'fixed', top: `${-window.scrollY}px`, left: '0px', right: '0px', width: '100%' };
      this.scrollState = { y: window.scrollY, x: window.scrollX, styles: {} };
      for (const [key, value] of Object.entries(properties)) {
        this.scrollState.styles[key] = { before: body.style.getPropertyValue(key), priority: body.style.getPropertyPriority(key), applied: value };
        body.style.setProperty(key, value);
      }
    }
    cleanup() {
      const wasExpanded = this.trigger?.getAttribute('aria-expanded') === 'true';
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.scrollState) {
        const state = this.scrollState;
        this.scrollState = null;
        for (const [key, value] of Object.entries(state.styles)) {
          // Do not overwrite styles another component changed while the menu was open.
          if (document.body.style.getPropertyValue(key) === value.applied) {
            if (value.before) document.body.style.setProperty(key, value.before, value.priority);
            else document.body.style.removeProperty(key);
          }
        }
        window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
      }
      if (wasExpanded && this.returnFocus && this.isConnected && !this.desktop?.matches) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.controller = null;
      if (this.trigger) this.trigger.hidden = true;
      if (this.fallback) this.fallback.hidden = false;
    }
  }
  customElements.define('fg-mobile-navigation', FeelGoodMobileNavigation);
})();
